import * as Sentry from '@sentry/vue'

/**
 * Инициализирует Sentry для Vue-приложения.
 * @param {import('vue').App} app - Инстанс Vue-приложения.
 * @param {object} options - Опции для инициализации.
 * @param {string} options.dsn - DSN ключ для Sentry.
 * @param {string} options.environment - Название окружения (e.g., 'production', 'staging').
 * @param {string} options.release - Идентификатор релиза (e.g., хэш коммита).
 */
export function initSentry(app, { dsn, environment, release }) {
	// Ничего не делаем, если DSN не предоставлен
	if (!dsn) {
		// console.warn('Sentry DSN not provided. Monitoring is disabled.')
		return
	}

	Sentry.init({
		app,
		dsn,
		environment,
		release,

		// Рекомендуется для лучшей отладки
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],

		// Настройка отслеживания производительности
		// 1.0 = 100% транзакций отправляется. В продакшене можно уменьшить.
		tracesSampleRate: 1.0,

		// Настройка записи сессий (Session Replay)
		replaysSessionSampleRate: 0.1, // 10% сессий будут записаны
		replaysOnErrorSampleRate: 1.0, // 100% сессий с ошибками будут записаны
	})
}
